import React, { useEffect, useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    date: "",
    message: "",
  });
const [isOpen, setIsOpen] = useState(() => {
  const now = new Date();
  return now.getHours() < 21;
});

useEffect(() => {
  const checkStatus = () => {
    const now = new Date();
    setIsOpen(now.getHours() < 21);
  };

  checkStatus();

  // Every minute status check
  const interval = setInterval(checkStatus, 60000);

  return () => clearInterval(interval);
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "+916304824076";

    const whatsappMessage = `
Hello Sree Sunrise Makeup Studio! 👋

I would like to book a makeup appointment.

✨ Booking Details
------------------------------
👤 Name: ${formData.name}
📞 Phone: ${formData.phone}
💄 Makeup Service: ${formData.service}
📅 Preferred Date: ${formData.date}

📝 Message:
${formData.message || "No additional message"}

Thank you!
    `.trim();

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsappMessage,
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <section
      id="contact"
      className="relative overflow-hidden bg-sunrise py-20 sm:py-24 lg:py-28"
    >
      {/* Background Decorations */}
      <div className="pointer-events-none absolute -left-40 top-20 h-96 w-96 rounded-full bg-sunrise-500/15 blur-3xl" />

      <div className="pointer-events-none absolute -right-40 bottom-0 h-[30rem] w-[30rem] rounded-full bg-blush-500/15 blur-3xl" />

      <div className="pointer-events-none absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-purple-500/5 blur-3xl" />

      <div className="section relative">
        {/* Header */}
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-sunrise-400">
            Get In Touch
          </p>

          <h2 className="mt-4 font-display text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl">
            Let's Create Your
            <span className="block text-blush-400">Perfect Look</span>
          </h2>

          <div className="mx-auto mt-6 h-1 w-16 rounded-full bg-gradient-to-r from-sunrise-500 to-blush-500" />

          <p className="mt-6 text-base leading-7 text-white/60 sm:text-lg">
            Ready to feel beautiful and confident? Get in touch with Sree
            Sunrise Makeup Studio and let's plan your perfect makeup experience.
          </p>
        </div>

        {/* Main Contact Area */}
        <div className="mt-14 grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-10">
          {/* Left - Contact Information */}
          <div className="space-y-5">
            {/* Contact Card */}
            <div className="glass rounded-3xl p-7 sm:p-8">
              <div className="mb-7">
                <p className="font-display text-2xl font-semibold text-white">
                  Contact Us
                </p>

                <p className="mt-2 text-sm leading-6 text-white/50">
                  We'd love to hear from you. Reach out and let's discuss your
                  makeup requirements.
                </p>
              </div>

              <div className="space-y-5">
                {/* Phone */}
                <a
                  href="tel:+919999999999"
                  className="group flex items-center gap-4 rounded-2xl border border-white/5 bg-white/5 p-4 transition duration-300 hover:border-sunrise-500/30 hover:bg-white/10"
                >
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sunrise-500/15 text-xl transition group-hover:bg-sunrise-500/25">
                    📞
                  </div>

                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/40">
                      Call Us
                    </p>

                    <p className="mt-1 font-medium text-white">
                      +916304824076
                    </p>
                  </div>
                </a>

                {/* WhatsApp */}
                <a
                  href="https://wa.me/+916304824076"
                  target="_blank"
                  rel="noreferrer"
                  className="group flex items-center gap-4 rounded-2xl border border-white/5 bg-white/5 p-4 transition duration-300 hover:border-blush-500/30 hover:bg-white/10"
                >
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blush-500/15 text-xl transition group-hover:bg-blush-500/25">
                    💬
                  </div>

                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/40">
                      WhatsApp
                    </p>

                    <p className="mt-1 font-medium text-white">Chat With Us</p>
                  </div>
                </a>

                {/* Email */}
                {/* <a
                  href="mailto:hello@sreesunrisemakeup.com"
                  className="group flex items-center gap-4 rounded-2xl border border-white/5 bg-white/5 p-4 transition duration-300 hover:border-sunrise-500/30 hover:bg-white/10"
                >
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sunrise-500/15 text-xl transition group-hover:bg-sunrise-500/25">
                    ✉️
                  </div>

                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/40">
                      Email
                    </p>

                    <p className="mt-1 break-all font-medium text-white">
                      hello@sreesunrisemakeup.com
                    </p>
                  </div>
                </a> */}

                {/* Location */}
                <div className="flex items-center gap-4 rounded-2xl border border-white/5 bg-white/5 p-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-blush-500/15 text-xl">
                    📍
                  </div>

                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/40">
                     Sree Sunrise Makeup Studio & Store
                    </p>

                    <p className="mt-1 font-medium text-white">
                      Wanaparthy, Telangana
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="glass rounded-3xl p-7 sm:p-8">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-display text-xl font-semibold text-white">
                    Studio Hours
                  </p>

                  <p className="mt-1 text-sm text-white/40">
                    We are here for you
                  </p>
                </div>

               {isOpen ? (
  <div className="flex items-center gap-2 rounded-full bg-green-400/10 px-3 py-1.5 text-xs font-medium text-green-300">
    <span className="h-2 w-2 animate-pulse rounded-full bg-green-400" />
    Open
  </div>
) : (
  <div className="flex items-center gap-2 rounded-full bg-red-400/10 px-3 py-1.5 text-xs font-medium text-red-400">
    <span className="h-2 w-2 rounded-full bg-red-500" />
    Closed
  </div>
)}
              </div>

              <div className="mt-5 space-y-3 text-sm">
                <div className="flex justify-between border-b border-white/5 pb-3">
                  <span className="text-white/50">Monday - Saturday</span>

                  <span className="font-medium text-white">
                    9:00 AM - 9:00 PM
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-white/50">Sunday</span>

                  <span className="font-medium text-white">By Appointment</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Booking Form */}
          <div className="glass rounded-3xl p-6 shadow-soft sm:p-8 lg:p-10">
            <div className="mb-8">
              <p className="font-display text-2xl font-semibold text-white sm:text-3xl">
                Book an Appointment
              </p>

              <p className="mt-2 text-sm leading-6 text-white/50">
                Tell us a little about your requirements and we'll get back to
                you shortly.
              </p>
            </div>

          
              <form onSubmit={handleSubmit} className="space-y-5">
                {/* Name + Phone */}
                <div className="grid gap-5 sm:grid-cols-2">
                  <div>
                    <label
                      htmlFor="name"
                      className="mb-2 block text-sm font-medium text-white/70"
                    >
                      Your Name
                    </label>

                    <input
                      id="name"
                      name="name"
                      type="text"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none placeholder:text-white/25 transition focus:border-sunrise-500/60 focus:bg-white/10 focus:ring-2 focus:ring-sunrise-500/10"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="phone"
                      className="mb-2 block text-sm font-medium text-white/70"
                    >
                      Phone Number
                    </label>

                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 XXXXX XXXXX"
                      className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none placeholder:text-white/25 transition focus:border-sunrise-500/60 focus:bg-white/10 focus:ring-2 focus:ring-sunrise-500/10"
                    />
                  </div>
                </div>

                {/* Service + Date */}
                <div className="grid gap-5 sm:grid-cols-2">
                  <div>
                    <label
                      htmlFor="service"
                      className="mb-2 block text-sm font-medium text-white/70"
                    >
                      Makeup Service
                    </label>

                    <select
                      id="service"
                      name="service"
                      required
                      value={formData.service}
                      onChange={handleChange}
                      className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none transition focus:border-sunrise-500/60 focus:ring-2 focus:ring-sunrise-500/10"
                    >
                      <option value="" className="bg-dusk-900">
                        Select service
                      </option>

                      <option value="Bridal Makeup" className="bg-dusk-900">
                        Bridal Makeup
                      </option>

                      <option value="Engagement Makeup" className="bg-dusk-900">
                        Engagement Makeup
                      </option>

                      <option value="Party Makeup" className="bg-dusk-900">
                        Party Makeup
                      </option>

                      <option
                        value="Traditional Makeup"
                        className="bg-dusk-900"
                      >
                        Traditional Makeup
                      </option>

                      <option value="Other" className="bg-dusk-900">
                        Other
                      </option>
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="date"
                      className="mb-2 block text-sm font-medium text-white/70"
                    >
                      Preferred Date
                    </label>

                    <input
                      id="date"
                      name="date"
                      type="date"
                      required
                      value={formData.date}
                      onChange={handleChange}
                      className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none transition focus:border-sunrise-500/60 focus:ring-2 focus:ring-sunrise-500/10"
                    />
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label
                    htmlFor="message"
                    className="mb-2 block text-sm font-medium text-white/70 text-leading-tight"
                  >
                    Tell Us More
                  </label>

                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your event, preferred look, number of people..."
                    className="w-full resize-none rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none placeholder:text-white/25 transition focus:border-sunrise-500/60 focus:bg-white/10 focus:ring-2 focus:ring-sunrise-500/10"
                  />
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="group flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-sunrise-600 to-blush-500 px-6 py-4 text-sm font-semibold text-white shadow-glow transition duration-300 hover:-translate-y-1 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-sunrise-400 focus:ring-offset-2 focus:ring-offset-dusk-900"
                >
                  Send Booking Request
                  <span className="transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>

                <p className="text-center text-xs text-white/30">
                  We'll contact you to confirm availability and appointment
                  details.
                </p>
              </form>
        
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 rounded-3xl border border-white/10 bg-gradient-to-r from-sunrise-500/10 via-blush-500/10 to-sunrise-500/10 p-8 text-center backdrop-blur-xl">
          <p className="font-display text-2xl font-semibold text-white">
            Prefer a quick chat?
          </p>

          <p className="mt-2 text-sm text-white/50">
            Message us directly on WhatsApp for faster assistance.
          </p>

          <a
            href="https://wa.me/919999999999"
            target="_blank"
            rel="noreferrer"
            className="btn-primary mt-5"
          >
            💬 Chat on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
